import { docodeHexResponse } from '../../../_common/common.utils';
import ProfitAndLossTypes from './profit-and-loss.types';

const INITIAL_STATE = {
	ProfitAndLossDetailsResponse: null,
	ProfitAndLossDetailsArr: [],
	ProfitAndLossDetailsCSVResponse: null,
	ProfitAndLossDetailsCSVArr: [],
};
const ProfitAndLossReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET PROFIT AND LOSS START *********************** */
		case ProfitAndLossTypes.GET_PROFIT_AND_LOSS_SUCCESS:
			return {
				...state,
				ProfitAndLossDetailsResponse: action.payload,
				ProfitAndLossDetailsArr: docodeHexResponse(
					action.payload,
					'GetProfitAndLossListKey',
				),
			};

		case ProfitAndLossTypes.GET_PROFIT_AND_LOSS_FAILURE:
			return {
				...state,
				ProfitAndLossDetailsResponse: action.payload,
				ProfitAndLossDetailsArr: [],
			};

		case ProfitAndLossTypes.GET_PROFIT_AND_LOSS_RESPONSE_CHANGED:
			return { ...state, ProfitAndLossDetailsResponse: null };
		/** ***************** GET PROFIT AND LOSS END *********************** */
		default:
			return state;
	}
};

export default ProfitAndLossReducer;
